import { Select, Row, Col, Form, Radio, Input, Anchor } from "antd";
const { Link } = Anchor;
const { Option } = Select;
const MDCAREEXPENSELIST = (props) => {
  return (
    <Form
      form={props.form}
      onFinish={props.onFinish}
      labelAlign="justify"
      layout="horizontal"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Row>
        <Col span={16} style={{ fontWeight: "bold" }}>
          MEDICARE EXPENSE LIST (FA Only)
        </Col>
        <Col span={8}>
          <Form.Item
            name="Status"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select defaultValue="Selected Status" style={{ width: 200 }}>
              <Option value="Selected Status">
                <strong>Selected Status</strong>
              </Option>
              <Option value="N/A">N/A</Option>
              <Option value="COMPLETE">COMPLETE</Option>
              <Option value="PENDING">PENDING</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name="Do you pay Medicare Expenses?"
        label="Do you pay Medicare Expenses?"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group>
          <Radio value="yes">Yes</Radio>
          <Radio value="no">No</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item name="Comments" label="Comments">
        <Input style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item name="Pending for:" label="Pending for:">
        <Input style={{ width: "100%" }} />
      </Form.Item>

      <Row>
        <Link
          href="http://content.dcf.ks.gov/ees/KEESM/Appendix/P-1_Medical_Expense_Guidelines_for_Food_Assistance_04-20.pdf"
          target="_blank"
          title="Medical Expense Guidlines for Food Assistance (P-1)"
        />
      </Row>
    </Form>
  );
};
export default MDCAREEXPENSELIST;
